import { create } from "zustand";
import { devtools } from "zustand/middleware";

/**
 * Tiny store that lets any surface (e.g. the footer's "Cookie preferences"
 * button) force the consent banner back open. The banner itself owns its
 * display logic; this store just carries the re-open signal.
 */
interface CookieConsentState {
  forceOpen: boolean;
  openPreferences: () => void;
  dismiss: () => void;
}

export const useCookieConsentStore = create<CookieConsentState>()(
  devtools(
    (set) => ({
      forceOpen: false,
      openPreferences: () => set({ forceOpen: true }),
      dismiss: () => set({ forceOpen: false }),
    }),
    { name: "cookie-consent-store" }
  )
);
